export let entryChannel = '';
export function setEntryChannel(value) {
    entryChannel = value;
}

export let campaignEntry = null;
export function setCampaignEntry(value) {
    campaignEntry = value;
}

export let campaign = false;
export function setCampaign(value) {
    campaign = value;
}

export let puppyEntry = false;
export function setPuppyEntry() {
    puppyEntry = true;
}

export let puppy = false;
export function setPuppy(value) {
    puppy = value;
}

export const healthText = {
    status: {
        0: 'in laufender Behandlung',
        1: 'Behandlung abgeschlossen'
    },
    occurrence: {
        0: 'einmalig',
        1: 'wiederkehrend',
        2: 'dauerhaft (chronisch)'
    }
}

export const vwoVariant = {
    control: '1',
    variant1: '2',
    variant2: '3',
    variant3: '4',
    variant4: '5',
}
